import React from 'react';
import { cn } from '../../lib/utils';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
interface BookCallButtonProps {
  onClick?: () => void;
  className?: string;
  to?: string;
  children?: React.ReactNode;
  showConfirmation?: boolean;
}
export const BookCallButton: React.FC<BookCallButtonProps> = ({
  onClick,
  className,
  to,
  children,
  showConfirmation
}) => {
  const navigate = useNavigate();
  const handleClick = () => {
    if (onClick) {
      onClick();
    } else if (to) {
      navigate(to);
    }
  };
  const buttonContent = <motion.button onClick={handleClick} className={cn('py-3 sm:py-4 px-6 sm:px-10 text-white font-bold rounded-xl text-lg sm:text-xl md:text-2xl w-full', 'bg-gradient-to-r from-blue-400/90 to-indigo-600/90 hover:from-blue-400 hover:to-indigo-600', 'transition-all duration-300 shadow-xl', 'active:scale-95 touch-manipulation', className)} whileHover={{
    scale: 1.05,
    boxShadow: '0 10px 25px -5px rgba(59, 130, 246, 0.5)'
  }} whileTap={{
    scale: 0.98
  }} data-id="element-85">
      {children || 'Continue to next step'}
    </motion.button>;
  return buttonContent;
};